import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';

import { COMPONENT_NAME, LEFT_SECTION, RIGHT_SECTION } from './locators';
import Grid from '../../../components/molecules/Grid';
import Container from '../../../components/molecules/Container';
import useStyles from './style';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';

const TwoColumnSubLayout = props => {
  const classes = useStyles(props);
  return (
    <Container data-locator={COMPONENT_NAME}>
      <Grid>
        <Grid item className={classes.root}>
          <Grid
            item
            className={classes.leftTwoColumnSubLayoutSection}
            data-locator={LEFT_SECTION}
          >
            <Placeholder name="vad-left-col" rendering={props.rendering} appConfig={props.appConfig} />
          </Grid>
          <Grid
            item
            className={classes.rightTwoColumnSubLayoutSection}
            data-locator={RIGHT_SECTION}
          >
            <Placeholder name="vad-right-col" rendering={props.rendering} appConfig={props.appConfig} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(TwoColumnSubLayout))
);
